import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { useParams, Link } from "react-router-dom";
import cookie from "js-cookie";
import ExportJsonExcel from "js-export-excel";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import Pagination from "../Pagination";
import categoryUserSitePublisherAction from "../../../../../store/actions/categoryUserSitePublisher";
import validateFormPermission from "../../../../../validtions/forms/category-user-site-publishers/add-categories-user-site-publishers";
import typeGroupSitePublisher from "../../TypeGroupSitePublisher";
import helperSpinner from "../../../../../helpers/spinner";
import helpersNumbers from "../../../../../helpers/numbers";
import helpersTime from "../../../../../helpers/time";
import typeActionCategoryUserSitePublisher from "../../../../../store/actions/typeActionCategoryUserSitePublisher";
import actionCookie from "../../../../../helpers/action-cookie";

function EditBannerCategorySitePublisher({
  categoryUser,
  dataSitePublisher,
  render,
  emptyPositions,
  setPositionsForEdit,
  setTypeAction,
  resetPositionInEditAction,
  resetDate,
}) {
  const [
    categorySitePublisherHasCampaign,
    setCategorySitePublisherHasCampaign,
  ] = useState(false);
  const [tagCategories, setTagCategories] = useState(<></>);
  const [tagSitePublisher, setTagSitePublisher] = useState();
  const [pagination, setPagination] = useState();
  const [categoryUserSitesPublisherData, setCategoryUserSitesPublisherData] =
    useState();

  const [message, setMessage] = useState();

  const previousPageUrl = cookie.get(actionCookie.PREVIOUS_PAGE_URL);

  const checkPreviousPageUrlIsAllPageSitePublishers = () => {
    if (
      previousPageUrl.includes("/publishers/") &&
      previousPageUrl.includes("/all-page")
    ) {
      return true;
    }
    return false;
  };
  setTypeAction({
    type_action: typeActionCategoryUserSitePublisher.EDIT,
  });

  const params = useParams();
  const typeAdvertisePublisher = params.typeAdvertise;
  const categorySitePublisherID = params.id;

  const history = useHistory();

  let countItemPerPage = 10;
  let countPage;
  let currentPage = 1;

  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
      emptyPositions();
      resetPositionInEditAction();
      resetDate();
    }
    checkCategorySitePublisherHasCampaign(categorySitePublisherID);
    getSitesPublisher();
    getCategoriesSitesPublisher();
    getCategoryUserSitesPublisherData();
  }, []);

  const checkCategorySitePublisherHasCampaign = async (
    categorySitePublisherID
  ) => {
    const campaign = await sendRequestGetCampaign(categorySitePublisherID);
    const result = Object.keys(campaign).length === 0 ? false : true;
    setCategorySitePublisherHasCampaign(result);
  };

  const sendRequestGetCampaign = async (categorySitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let campaigns;
    try {
      campaigns = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/banner/simple/category-user-site-publisher/" +
          categorySitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return campaigns.data.data;
  };

  const getCategoryUserSitesPublisherData = async () => {
    const categoryUserSitesPublisherData =
      await sendRequestCategoryUserSitesPublisherData(categorySitePublisherID);
    if (!categoryUserSitesPublisherData) {
      return;
    }
    setCategoryUserSitesPublisherData(categoryUserSitesPublisherData);
    if (Object.keys(categoryUserSitesPublisherData).length !== 0) {
      if (!checkPreviousPageUrlIsAllPageSitePublishers()) {
        setPositionsForEdit({
          dataSitePublisher: categoryUserSitesPublisherData.sites,
        });
      }
    }
  };

  const sendRequestCategoryUserSitesPublisherData = async (
    categorySitePublisherID
  ) => {
    const headersRequest = getHeaderForRequest();
    let categoryUserSitesPublisherData;
    try {
      categoryUserSitesPublisherData = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-user-site-publishers/" +
          categorySitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryUserSitesPublisherData.data.data;
  };

  const getCategoriesSitesPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categories = await sendRequestGetCategoryAllPublisher();
    setTagCategories(generateTagCategories(categories));
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const getSitesPublisher = async (searchSite = null, categoryName = null) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    const sitesPublisher = await sendRequestSitesPublisher(
      currentPage,
      searchSite,
      categoryName,
      typeAdvertisePublisher
    );
    setTagSitePublisher(generateTagSitesPublisher(sitesPublisher));
    if (countPage != 1) {
      setPagination(generatePagination(countPage, currentPage));
    } else {
      setPagination();
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const generateTagSitesPublisher = (sitesPublisher) => {
    countPage = sitesPublisher.total_page;
    return sitesPublisher.data.map((sitePublisher, index) => {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>
            <a href={sitePublisher.url} target="_blank">
              {sitePublisher.url}
            </a>
          </td>
          <td>{sitePublisher.categories.join(" - ")}</td>
          <td>
            <div>
              <span>
                <Link
                  to={`/manage/publishers/alternative/${sitePublisher.id}/all-page/${categorySitePublisherID}`}
                  className="btn btn-info"
                >
                  <i className="fa fa-eye"></i>
                </Link>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generatePagination = (countPage, currentPage) => {
    return (
      <>
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
        <div className="form-group m-0 d-flex flex-column flex-sm-row align-items-center">
          <label className="text-nowrap m-0 pl-2">
            تعداد سطر در هر صفحه :{" "}
          </label>
          <input
            type="number"
            className="form-control "
            id="count-per-page"
            defaultValue={countItemPerPage}
            onKeyUp={changePerPageItem}
          />
        </div>
      </>
    );
  };

  const sendRequestSitesPublisher = async (
    currentPage,
    searchSite = null,
    searchCategoryName = null,
    searchTypeAdvertiseName = null
  ) => {
    if (searchSite) {
      searchSite = "&site=" + searchSite;
    } else {
      searchSite = "";
    }

    if (searchCategoryName) {
      searchCategoryName = "&category=" + searchCategoryName;
    } else {
      searchCategoryName = "";
    }
    if (searchTypeAdvertiseName) {
      searchTypeAdvertiseName = "&types[]=" + searchTypeAdvertiseName;
    } else {
      searchTypeAdvertiseName = "";
    }

    const headersRequest = getHeaderForRequest();
    let sitePublishers;
    try {
      sitePublishers = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers?page=" +
          currentPage +
          "&number=" +
          countItemPerPage +
          searchSite +
          searchCategoryName +
          searchTypeAdvertiseName,
        headersRequest
      );
    } catch (error) {
      return false;
    }

    return sitePublishers.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    let pageNumber = e.target.attributes[1].value;
    await getSitesPublisherWithSearchItems(pageNumber);

    setPagination(generatePagination(countPage, pageNumber));
  };

  const changePerPageItem = async () => {
    countItemPerPage = document.getElementById("count-per-page").value;
    await searchInSitesPublishers();
  };

  const searchInSitesPublishers = async () => {
    await getSitesPublisherWithSearchItems(currentPage);
  };

  const getSitesPublisherWithSearchItems = async (pageNumber) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const searchSite = document.getElementById("site").value;
    let categoryName = document.getElementById(
      "categories-site-publishers"
    ).value;

    if (categoryName == "انتخاب کنید") {
      categoryName = null;
    }
    const sitesPublisher = await sendRequestSitesPublisher(
      pageNumber,
      searchSite,
      categoryName,
      typeAdvertisePublisher
    );
    setTagSitePublisher(generateTagSitesPublisher(sitesPublisher));
    if (countPage != 1) {
      setPagination(generatePagination(countPage, currentPage));
    } else {
      setPagination();
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const generateTagCategories = (categories) => {
    return categories.map((category, index) => {
      if (categoryUser != category.cas_name) {
        return (
          <>
            <option key={index}>{category.cas_name}</option>
          </>
        );
      }
    });
  };

  const sendRequestGetCategoryAllPublisher = async () => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/category-site-publishers",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryAllPublisher.data.data;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDataForm();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestEditCategoryUserSitePublisher =
      await sendRequestEditCategoryUserSitePublisher(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestEditCategoryUserSitePublisher) {
      return;
    }
    emptyPositions();
    resetPositionInEditAction();
    history.push(
      "/manage/publishers/all-banner-category-site-publisher-alternative"
    );
  };

  const goScrollIntoTag = (tagID) => {
    const element = document.getElementById(tagID);
    element.scrollIntoView();
  };

  const sendRequestEditCategoryUserSitePublisher = async (dataForm) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/category-user-site-publishers/alternative/" +
          categorySitePublisherID,
        dataForm,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      goScrollIntoTag("add-group-site-publisher");
      return false;
    }

    return true;
  };

  const getDataForm = () => {
    const typeGroupPublisher = typeGroupSitePublisher.getTypeGroupPublisher(
      typeAdvertisePublisher
    );
    return {
      name: document.getElementById("name").value,
      type_id: "" + typeGroupPublisher,
      amount: getPriceCategoryUserSitePublisher(dataSitePublisher) + "",
      sites: dataSitePublisher,
    };
  };

  const exportReportExcel = () => {
    var option = {};
    option.fileName = "گزارش سایت های انتخاب شده";
    let dataExcelFile = [
      {
        one: "عنوان گروه ",
        two: document.getElementById("name").value.trim() + "",
      },
      {
        one: "مبلغ گروه ",
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceCategoryUserSitePublisher(dataSitePublisher)
          )
        ),
      },
      {
        one: "تاریخ شروع",
        two: helpersNumbers.toPersianNum(
          helpersTime.convertGregorianToJalali(
            categoryUserSitesPublisherData?.start_date
          )
        ),
        three: "تاریخ پایان",
        four: helpersNumbers.toPersianNum(
          helpersTime.convertGregorianToJalali(
            categoryUserSitesPublisherData?.end_date
          )
        ),
      },
      {
        one: "=======================",
        two: "=======================",
      },
    ];
    for (let key in dataSitePublisher) {
      dataExcelFile = [
        ...dataExcelFile,
        ...generateEachSitePublisherArrayReportExportExcel(
          dataSitePublisher[key]
        ),
        { one: "=======================", two: "=======================" },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const generateEachSitePublisherArrayReportExportExcel = (
    sitePublisherData
  ) => {
    let sitePublisherUrl = sitePublisherData.url;

    let dataEachSitePublisherExcelFile = [
      {
        one: sitePublisherUrl,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceSitePublisher(sitePublisherData)
          )
        ),
      },
    ];

    for (const key in sitePublisherData) {
      if (key === "url") {
        continue;
      }

      const item = sitePublisherData[key];
      dataEachSitePublisherExcelFile = [
        ...dataEachSitePublisherExcelFile,
        ...generatePageDataReportExportExcel(item),
      ];
    }
    return dataEachSitePublisherExcelFile;
  };

  const generatePageDataReportExportExcel = (sitePublisherData) => {
    return [
      {
        one: sitePublisherData.title,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(sitePublisherData.price)
        ),
      },
      { ...sitePublisherData.positions },
      {
        one: "",
        two: "",
      },
    ];
  };

  const getPriceSitePublisher = (sitePublisherData) => {
    let pricePage = 0;
    const newSitePublisherData = { ...sitePublisherData };
    for (const key in newSitePublisherData) {
      if (key == "url") {
        continue;
      }
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1
                  style={{ fontSize: "14px" }}
                  className="px-5 py-1  bg-warning"
                >
                  اضافه کردن گروه سایت های نمایش دهنده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body" id="add-group-site-publisher">
              <div className="text-left pb-2">
                <Link
                  to="/manage/publishers/all-banner-category-site-publisher-alternative"
                  className="btn btn-success"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}
              {categorySitePublisherHasCampaign === true ? (
                <div className="alert alert-warning">
                  <p className="text-white m-0">
                    <i className="fa fa-info pl-2"></i>
                    گروه نمایش دهنده شما یک کمپین دارد و قابل ویرایش نیست.
                  </p>
                </div>
              ) : (
                <></>
              )}
              <form onSubmit={sendForm}>
                <div className="form-group">
                  <label>نام گروه</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="نام گروه"
                    id="name"
                    defaultValue={categoryUserSitesPublisherData?.name}
                    required
                  />
                </div>

                <div className="form-group">
                  <span>
                    <label>تاریخ شروع : </label>
                    <span className="number-finance">
                      {categoryUserSitesPublisherData !== undefined ? (
                        helpersNumbers.toPersianNum(
                          helpersTime.convertGregorianToJalali(
                            categoryUserSitesPublisherData?.start_date
                          )
                        )
                      ) : (
                        <></>
                      )}
                    </span>
                  </span>
                  <span className="pr-3">
                    <label>تاریخ پایان : </label>
                    <span className="number-finance">
                      {categoryUserSitesPublisherData !== undefined ? (
                        helpersNumbers.toPersianNum(
                          helpersTime.convertGregorianToJalali(
                            categoryUserSitesPublisherData?.end_date
                          )
                        )
                      ) : (
                        <></>
                      )}
                    </span>
                  </span>
                </div>

                <hr />
                <div className="form-group">
                  <div className="container-fluid p-0">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div>
                          <label>جستجو آدرس سایت</label>
                        </div>
                        <div>
                          <input
                            onKeyUp={searchInSitesPublishers}
                            className="form-control"
                            id="site"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div>
                          <div>
                            <label>انتخاب دسته بندی موضوع</label>
                          </div>
                          <div>
                            <select
                              onChange={searchInSitesPublishers}
                              id="categories-site-publishers"
                              className="form-control"
                            >
                              <option>انتخاب کنید</option>
                              {tagCategories}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="pt-3 pr-2">
                        <span>مبلغ گروه : </span>
                        <span className="px-2 letter-spacing-finance-number">
                          {helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(
                              getPriceCategoryUserSitePublisher(
                                dataSitePublisher
                              )
                            )
                          )}
                        </span>
                        <span>هزارتومان</span>
                      </div>
                      <div className="table-responsive pt-3">
                        <table className="table table-bordered table-dark tbl-td-white-space table-hover">
                          <thead>
                            <tr>
                              <td>#</td>
                              <td>نمایش دهنده</td>
                              <td>دسته بندی موضوع</td>
                              <td>نمایش صفحات</td>
                            </tr>
                          </thead>
                          <tbody>{tagSitePublisher}</tbody>
                        </table>
                      </div>
                      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
                        {pagination}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <span className="pl-2">
                    <div
                      className="btn btn-outline-success"
                      onClick={exportReportExcel}
                    >
                      <span className="pl-2">
                        <i className="fa fa-file-excel-o"></i>
                      </span>
                      <span>خروجی فایل Excel</span>
                    </div>
                  </span>
                  {categorySitePublisherHasCampaign === false ? (
                    <button type="submit" className="btn btn-primary">
                      ویرایش کردن
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    categoryUser: state.main.categoryUser,
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    render: state.categoryUserSitePublisher.render,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    emptyPositions: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.EMPTY_POSITION,
        payload: action,
      });
    },
    setPositionsForEdit: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_POSITION_FOR_EDIT,
        payload: action,
      });
    },
    setTypeAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.SET_TYPE_ACTION,
        payload: action,
      });
    },
    resetPositionInEditAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.RESET_POSITION_IN_EDIT_ACTION,
        payload: action,
      });
    },
    resetDate: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.RESET_DATE,
        payload: action,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditBannerCategorySitePublisher);
